// extracted by mini-css-extract-plugin
export var borderRadius = "_bd-4";
export var large = "_bd-3";
export var logoContainer = "_bd-0";
export var nameLogo = "_bd-2";
export var small = "_bd-1";